import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { LibraryElementEnum } from 'src/shared/enums/LibraryElementEnum'

const toggleConfigItems: LibraryElementEnum[] = [
  LibraryElementEnum.LibraryWebsiteButton,
  LibraryElementEnum.LibraryLoginButton,
  LibraryElementEnum.LibraryRegistrationButton,
  LibraryElementEnum.LibraryText,
  LibraryElementEnum.LibraryTwitterTweetButton,
  // LibraryElementEnum.LibraryRawHTML,
  LibraryElementEnum.LibraryWebsiteLanguageSwitcher,
]

const availableItemsForWebsiteHeader: EntityTypeEnum[] = [
  EntityTypeEnum.WebsiteButton,
  EntityTypeEnum.LoginButton,
  EntityTypeEnum.RegistrationButton,
  EntityTypeEnum.Text,
  EntityTypeEnum.TwitterTweetButton,
  EntityTypeEnum.WebsiteLanguageSwitcher,
  EntityTypeEnum.WebsiteLogo,
  EntityTypeEnum.Menu,
  // EntityTypeEnum.RawHTML,
]

export const shouldShowRegistrationButtonInWebsiteHeader = (
  isWhiteLabel: boolean,
  isSystemeDomain: boolean,
): boolean => isWhiteLabel || isSystemeDomain

export const getToggleConfigItems = (
  excludedElements: LibraryElementEnum[] = [],
): LibraryElementEnum[] =>
  toggleConfigItems.filter(item => !excludedElements.includes(item))

export const getAvailableItemsForWebsiteHeader = (
  excludedTypes: EntityTypeEnum[] = [],
): EntityTypeEnum[] =>
  availableItemsForWebsiteHeader.filter(item => !excludedTypes.includes(item))

export const getDefaultButtonSettings = () => {
  return {
    background: 'rgb(0, 160, 255)',
    border: {
      color: '',
      radius: {
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      },
      style: BorderStyleEnum.none,
    },
    mobileBorder: {
      color: '',
      radius: {
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      },
      style: BorderStyleEnum.none,
    },
    subText: '',
    margin: {
      marginLeft: 15,
      marginBottom: 0,
      marginTop: 0,
      marginRight: 0,
    },
    mobileMargin: {
      marginLeft: 10,
      marginBottom: 0,
      marginTop: 0,
      marginRight: 0,
    },
    padding: {
      paddingBottom: 5,
      paddingTop: 5,
      paddingLeft: 30,
      paddingRight: 30,
    },
    textFontSize: 14,
    lineHeight: 20,
    mobileTextFontSize: 12,
    mobileLineHeight: 18,
  }
}

export const getDefaultMarginSettings = () => {
  return {
    margin: {
      marginLeft: 15,
      marginBottom: 0,
      marginTop: 0,
      marginRight: 0,
    },
    mobileMargin: {
      marginLeft: 10,
      marginBottom: 0,
      marginTop: 0,
      marginRight: 0,
    },
  }
}
